import React from 'react';
import { Helmet } from 'react-helmet';

const LocalBusinessSchema = () => {
  const businessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Inkox Custom Printing",
    "image": "https://inkox.com/static/media/logo.f3b48d00cb7bd2636e77.webp",
    "url": "https://inkox.com/",
    "telephone": "+1-800-123-4567",

    "openingHours": "24 hours",
   
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(businessSchema)}
      </script>
    </Helmet>
  );
};

export default LocalBusinessSchema;
